import { NgModule } from "@angular/core";
import { TooltipIfOverflowDirective } from "./tooltip-if-overflow.directive";
import { UiTooltipComponent } from "./tooltip.component";
import { UiTooltipDirective } from "./tooltip.directive";

@NgModule({
  imports: [UiTooltipDirective, UiTooltipComponent, TooltipIfOverflowDirective],
  exports: [UiTooltipDirective, UiTooltipComponent, TooltipIfOverflowDirective],
})
export class UiTooltipModule {}
